import enviro from 'enviro';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import InteractiveEducationButton from '../../interactiveEducation/components/InteractiveEducationButton';
import { isInternalPortal } from '../../accounts';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VideoControls = ({
  additionalTracking,
  enableQuizMe = false,
  enableSummarize = false,
  enableAdaptToIndustry = false,
  displayInteractiveEducation,
  handleDisplayInteractiveEducation,
  interactiveEducationEnabled = false,
  onFinish
}) => {
  const {
    isNotLaptop
  } = useMediaQuery();

  // Temp local flag
  const releaseNewInteractiveButtonStyle = enviro.isQa() || isInternalPortal();
  const buttonSize = releaseNewInteractiveButtonStyle ? 'sm' : 'md';
  const handleInteractiveEducationClick = flag => () => handleDisplayInteractiveEducation && handleDisplayInteractiveEducation(flag);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    borderEndEndRadius: "100",
    borderEndStartRadius: "100",
    flexDirection: "row",
    flexWrap: "nowrap",
    gap: "200",
    children: [/*#__PURE__*/_jsx(Flex, {
      flexGrow: 1,
      justifyContent: "center",
      children: interactiveEducationEnabled && isNotLaptop && (enableQuizMe || enableSummarize || enableAdaptToIndustry) && /*#__PURE__*/_jsxs(_Fragment, {
        children: [enableSummarize && /*#__PURE__*/_jsx(InteractiveEducationButton, {
          action: "ai-summarize-button-rendered",
          additionalTracking: additionalTracking,
          display: displayInteractiveEducation === 'SUMMARIZATION',
          handleClick: handleInteractiveEducationClick('SUMMARIZATION'),
          size: buttonSize,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.summarize.summarizeTitle"
          }),
          use: 'secondary'
        }), enableAdaptToIndustry && /*#__PURE__*/_jsx(InteractiveEducationButton, {
          action: "ai-adapt-to-industry-button-rendered",
          additionalTracking: additionalTracking,
          display: displayInteractiveEducation === 'ADAPT_TO_INDUSTRY',
          handleClick: handleInteractiveEducationClick('ADAPT_TO_INDUSTRY'),
          size: buttonSize,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.adaptToIndustry.title"
          }),
          use: 'secondary'
        }), enableQuizMe && /*#__PURE__*/_jsx(InteractiveEducationButton, {
          action: "ai-quiz-me-button-rendered",
          additionalTracking: additionalTracking,
          display: displayInteractiveEducation === 'QUIZ_ME',
          handleClick: handleInteractiveEducationClick('QUIZ_ME'),
          size: buttonSize,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.quiz.quizMeTitle"
          }),
          use: 'secondary'
        })]
      })
    }), /*#__PURE__*/_jsx(Flex, {
      flexShrink: 0,
      children: !!onFinish && /*#__PURE__*/_jsx(Button, {
        onClick: onFinish,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.common.next"
        })
      })
    })]
  });
};
export default VideoControls;